import { PlatformClient as n } from "@coveo/platform-client";
import { ActivitiesInternalResource as t } from "./resources/ActivitiesInternalResource.js";
import { AgentConfigurationResource as i } from "./resources/agent-configuration/AgentConfigurationResource.js";
import { AnswerResource as s } from "./resources/answer/AnswerResource.js";
import { AutomationFreezesResource as c } from "./resources/AutomationFreezesResource.js";
import { BatchAnswerResource as a } from "./resources/batch-answer/BatchAnswerResource.js";
import { CaseAssistConfigsInternalResource as u } from "./resources/CaseAssistConfigstInternalResource.js";
import { ChunkInspectorResource as m } from "./resources/chunk-inspector/ChunkInspectorResource.js";
import { CommerceResource as p } from "./resources/commerce/Commerce.js";
import { ConditionResource as f } from "./resources/ConditionResource.js";
import { CrawlingModuleInternalResource as l } from "./resources/CrawlingModuleInternalResource.js";
import { CRGADashboardResource as y } from "./resources/crga-dashboard/CRGADashboardResource.js";
import { DataServiceResource as I } from "./resources/DataServiceResource.js";
import { DocumentIdentityResource as g } from "./resources/DocumentIdentityResource.js";
import { ExportServiceResource as R } from "./resources/ExportServiceResource.js";
import { ExtensionInternalResource as k } from "./resources/ExtensionInternalResource.js";
import { InAppWidgetResource as h } from "./resources/InAppWidgetResource.js";
import { InsightPanelConfigsInternalResource as C } from "./resources/InsightPanelConfigsInternalResource.js";
import { HostedPagesInternalResource as P } from "./resources/HostedPagesInternalResource.js";
import { IPXInterfaceExperimentalResource as S } from "./resources/IPXInterfaceResource.js";
import { LicenseInternalResource as d } from "./resources/LicenseInternalResource.js";
import { LogicalIndexesResource as v } from "./resources/LogicalIndexesResource.js";
import { MCPConfigurationsResource as z } from "./resources/MCPConfigurationsResource.js";
import { MCPPipelinesResource as x } from "./resources/MCPPipelinesResource.js";
import { ModelsInternalResource as A } from "./resources/ModelsInternalResource.js";
import { NextGenSearchPagesInternalResource as w } from "./resources/NextGenSearchPagesInternalResource.js";
import { NotificationEventResource as M } from "./resources/NotificationEventResource.js";
import { OrganizationInternalResource as E } from "./resources/OrganizationInternalResource.js";
import { OrganizationCustomerKeysResource as D } from "./resources/OrganizationCustomerKeysResource.js";
import { OrganizationDefinitionResource as O } from "./resources/OrganizationDefinitionResource.js";
import { OrganizationHealthMonitoringResource as b } from "./resources/OrganizationHealthMonitoringResource.js";
import { OrganizationMonitoringResource as G } from "./resources/OrganizationMonitoringResource.js";
import { OrganizationSettingsResource as H } from "./resources/OrganizationSettingsResource.js";
import { PipelineInternalResource as j } from "./resources/PipelineInternalResource.js";
import { PipelineSettingsResource as F } from "./resources/PipelineSettingsResource.js";
import { PreviewResource as K } from "./resources/PreviewResource.js";
import { PrivilegesResource as L } from "./resources/PrivilegesResource.js";
import { ProjectInternalResource as N } from "./resources/ProjectInternalResource.js";
import { ReportInternalResource as T } from "./resources/ReportInternalResource.js";
import { SalesforceSourceConfigurationInternalResource as W } from "./resources/SalesforceSourceConfigurationInternalResource.js";
import { SchemaServiceTemporaryResource as B } from "./resources/SchemaServiceTemporaryResource.js";
import { SearchInterfacesInternalResource as X } from "./resources/SearchInterfacesInternalResource.js";
import { SearchPagesInternalResource as q } from "./resources/SearchPagesInternalResource.js";
import { SourcesInternalResource as J } from "./resources/SourcesInternalResource.js";
import { SecurityCacheInternalResource as Q } from "./resources/SecurityCacheInternalResource.js";
const U = [
  { key: "activitiesInternal", resource: t },
  { key: "agentConfiguration", resource: i },
  { key: "answer", resource: s },
  { key: "automationFreezes", resource: c },
  { key: "batchAnswer", resource: a },
  { key: "caseAssistConfigsInternal", resource: u },
  { key: "chunkInspector", resource: m },
  { key: "commerce", resource: p },
  { key: "condition", resource: f },
  { key: "crawlingModuleInternal", resource: l },
  { key: "crgaDashboard", resource: y },
  { key: "dataService", resource: I },
  { key: "documentIdentity", resource: g },
  { key: "exportService", resource: R },
  { key: "extensionInternal", resource: k },
  { key: "inAppWidget", resource: h },
  { key: "insightPanelConfigsInternal", resource: C },
  { key: "hostedPagesInternal", resource: P },
  { key: "ipxInterfaceExperimental", resource: S },
  { key: "licenseInternal", resource: d },
  { key: "logicalIndexes", resource: v },
  { key: "mcpConfigurations", resource: z },
  { key: "mcpPipelines", resource: x },
  { key: "modelsInternal", resource: A },
  { key: "nextGenSearchPagesInternal", resource: w },
  { key: "notificationEvent", resource: M },
  { key: "organizationInternal", resource: E },
  { key: "organizationCustomerKeys", resource: D },
  { key: "organizationDefinition", resource: O },
  { key: "organizationHealthMonitoring", resource: b },
  { key: "organizationMonitoring", resource: G },
  { key: "organizationSettings", resource: H },
  { key: "pipelineInternal", resource: j },
  { key: "pipelineSettings", resource: F },
  { key: "preview", resource: K },
  { key: "privileges", resource: L },
  { key: "projectInternal", resource: N },
  { key: "reportInternalResource", resource: T },
  { key: "salesforceSourceConfigurationInternal", resource: W },
  { key: "schemaServiceTemporary", resource: B },
  { key: "searchInterfacesInternal", resource: X },
  { key: "searchPagesInternal", resource: q },
  { key: "sourcesInternal", resource: J },
  { key: "securityCacheInternal", resource: Q }
];
class Te extends n {
  constructor(e) {
    super(e), U.forEach(({ key: r, resource: o }) => {
      this[r] = new o(this.API, this.ServerlessAPI);
    });
  }
}
export {
  Te as PrivatePlatformClient
};
//# sourceMappingURL=PrivatePlatformClient.js.map
